import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Transaction } from '@/types';

async function fetchTransactions(ledgerId: string): Promise<Transaction[]> {
  const { data } = await api.get<Transaction[]>(`/ledger/transactions/ledger/${ledgerId}`);
  return data;
}

export function useLedgerTransactions(ledgerId?: string) {
  return useQuery({
    queryKey: ['ledger', ledgerId, 'transactions'],
    queryFn: () => fetchTransactions(ledgerId!),
    enabled: !!ledgerId,
  });
}
